import useAuth from "../hooks/useAuth";
import { useApi } from "../hooks/useApi";
import { Button } from "@ui";
import { usePathname } from "next/navigation";
import { useState } from "react";

const EmailVerificationBanner = () => {
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const [emailSend, setEmailSend] = useState(false);
    const { user, isAuthenticated, isLoading: isLoadingAuth } = useAuth();
    // the onboarding confirms the address with its own code step
    const isOnboarding = usePathname()?.startsWith("/onboarding");

    const handleResendEmail = () => {
        setIsLoading(true);
        void api({
            url: "verification/resend",
            method: "POST",
            onBefore: () => setIsLoading(false),
            onSuccess: () => {
                setEmailSend(true);
                alert("E-Mail wurde erneut gesendet! Bitte überprüfe dein Postfach");
            }
        });
    };

    if (!isOnboarding && !isLoadingAuth && isAuthenticated && !user?.isVerified)
        return <div className="tw-fixed tw-left-4 tw-bottom-4 tw-w-1/3 tw-z-[99999] tw-my-4">
            <div className="tw-card-flat tw-bg-white tw-shadow-lg">
                <h5 className="tw-font-semibold">Deine E-Mail Adresse ist noch nicht verifiziert</h5>
                <p>Schaue bitte in deinen E-Mail Postfach und auch im Spam-Ordner nach der Verifizierungsmail und klicke
                    auf den
                    Link in der Mail. Du hast keine E-Mail bekommen oder der Link ist abgelaufen? Dann klicke auf E-Mail
                    erneut senden.</p>
                <Button block onPress={handleResendEmail} isLoading={isLoading} disabled={emailSend}>E-Mail erneut
                    senden</Button>
            </div>
        </div>;

    return null;
};

export default EmailVerificationBanner;